export default __webpack_public_path__ + "static/media/artefactsImage.cddf6b7b.svg";